var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.09436 19.2502H17.8994C19.311 19.2502 20.191 17.7194 19.4852 16.5002L12.5827 4.57438C11.8769 3.35521 10.1169 3.35521 9.41102 4.57438L2.50852 16.5002C1.80269 17.7194 2.68269 19.2502 4.09436 19.2502ZM10.9969 12.8335C10.4927 12.8335 10.0802 12.421 10.0802 11.9169V10.0835C10.0802 9.57938 10.4927 9.16688 10.9969 9.16688C11.501 9.16688 11.9135 9.57938 11.9135 10.0835V11.9169C11.9135 12.421 11.501 12.8335 10.9969 12.8335ZM11.9135 16.5002H10.0802V14.6669H11.9135V16.5002Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorWarningIcon);
export default __webpack_public_path__ + "static/media/ErrorWarningIcon.5b2e13a1f858ba527660962902667817.svg";
export { ForwardRef as ReactComponent };